import { redirectToStore } from '../utils/deviceDetection'
import { QRCodeSVG } from 'qrcode.react'
import '../styles/DownloadSection.css'

function DownloadSection() {
  const appStoreLink = 'https://apps.apple.com/us/app/breakout-meeting/id6753223729'

  return (
    <section className="download-section" role="region" aria-labelledby="download-title">
      <div className="download-container">
        <header className="download-header">
          <h2 id="download-title" className="download-title">Ready to Break Out?</h2>
          <p className="download-subtitle">
            Join a community building real connections through shared activities and common interests
          </p>
        </header>
        
        <div className="download-options" role="region" aria-label="Download Options">
          <div className="qr-section">
            <div className="qr-code-container" role="img" aria-label="QR Code to download Breakout app">
              <div className="qr-code-wrapper">
                <QRCodeSVG 
                  value={appStoreLink} 
                  size={160}
                  level="H"
                  includeMargin={false}
                  title="Scan to download Breakout app"
                />
              </div>
            </div>
          </div>
          
          <div className="download-divider" aria-hidden="true">
            <span>or</span>
          </div>
          
          <div className="store-button-section">
            <button 
              className="app-store-btn"
              onClick={() => redirectToStore('ios')}
              aria-label="Download Breakout on the App Store"
              type="button"
            >
              <span className="store-btn-text">Download on the App Store</span>
            </button>
          </div>
        </div>
        
        <footer className="download-footer">
          <p className="platform-availability">
            <span className="available-now">Available on iOS</span>
            <span className="separator">•</span>
            <span className="coming-soon">Android coming soon</span>
          </p>
        </footer>
      </div>
    </section>
  )
}

export default DownloadSection
